"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var OrderApi = /** @class */ (function () {
    function OrderApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询订单,下订单
     * @method GET 查询订单
     * @method POST 下订单
     *
     */
    OrderApi.prototype.Order = function () {
        return this.http
            .url("/api/Order")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    /**
     * 获取订单
     * @method GET 获取订单
     *
     * @params id 无说明
     */
    OrderApi.prototype.OrderById = function (id) {
        return this.http
            .url("/api/Order/" + id)
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取订单小计
     * @method POST 获取订单小计
     *
     */
    OrderApi.prototype.subtotal = function () {
        return this.http
            .url("/api/Order/subtotal")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 通过微信发起订单支付
     * @method POST 通过微信发起订单支付
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.wxpay = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/wxpay")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 通过微信机器人支付
     * @method POST 通过微信机器人支付
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.wxbotpay = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/wxbotpay")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 设置订单为线下支付
     * @method POST 设置订单为线下支付
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.offlinepay = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/offlinepay")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 确认订单线下支付成功
     * @method POST 确认订单线下支付成功
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.confirmpay = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/confirmpay")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 拒绝订单线下支付
     * @method POST 拒绝订单线下支付
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.declinepay = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/declinepay")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 修改订单地址
     * @method PUT 修改订单地址
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.receiver = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/receiver")
            .addSecurityHeaders()
            .support('PUT');
    };
    /**
     * 查询物流信息
     * @method GET 查询物流信息
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.logistic = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/logistic")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 发货
     * @method POST 发货
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.deliver = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/deliver")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 确认收货
     * @method POST 确认收货
     *
     * @params orderId 无说明
     */
    OrderApi.prototype.takedelivery = function (orderId) {
        return this.http
            .url("/api/Order/" + orderId + "/takedelivery")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 购买会员小计
     * @method POST 购买会员小计
     *
     */
    OrderApi.prototype.subTotalMember = function () {
        return this.http
            .url("/api/Order/member/subtotal")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 购买会员下单
     * @method POST 购买会员下单
     *
     */
    OrderApi.prototype.memberOrder = function () {
        return this.http
            .url("/api/Order/member")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 购买会员升级小计
     * @method POST 购买会员升级小计
     *
     */
    OrderApi.prototype.subTotalMemberUpgrade = function () {
        return this.http
            .url("/api/Order/memberupgrade/subtotal")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 购买会员升级下单
     * @method POST 购买会员升级下单
     *
     */
    OrderApi.prototype.memberupgrade = function () {
        return this.http
            .url("/api/Order/memberupgrade")
            .addSecurityHeaders()
            .support('POST');
    };
    OrderApi.diOptions = di_1.default.options({
        name: "OrderApi",
        scope: "Singleton"
    });
    return OrderApi;
}());
exports.OrderApi = OrderApi;
exports.default = OrderApi;
